import { useEffect, useState } from "react"
import { Autocomplete } from "@material-ui/lab"
import { TextField } from "@material-ui/core"
import TipoOperacao from '../../../../src/enums/tipoOperacao'

export default function OrgaosJurisdicionadosUsuario({ tipoOperacao, orgaoUsuarioLogado, listaOrgaosJurisdicionados }) {
    const [options, setOptions] = useState([])
    const [open, setOpen] = useState(false)

    useEffect(() => {
        let _options = []

        if (orgaoUsuarioLogado !== null && orgaoUsuarioLogado !== undefined) {
            if (tipoOperacao === TipoOperacao.CADASTRO) {
                _options.push({
                    id: orgaoUsuarioLogado.id,
                    nome: orgaoUsuarioLogado.nome
                })
            }
            else if (tipoOperacao === TipoOperacao.ALTERACAO) {
                for (let index = 0; index < listaOrgaosJurisdicionados.length; index++) {
                    _options.push({
                        id: listaOrgaosJurisdicionados[index].setorIdOrgaoJurisdicionado,
                        nome: listaOrgaosJurisdicionados[index].nomeOrgaoJurisdicionado
                    })
                }
            }
        }

        setOptions(_options)

    }, [tipoOperacao, orgaoUsuarioLogado, listaOrgaosJurisdicionados])

    return (
        <Autocomplete
            multiple
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={options}
            getOptionLabel={(option) => option.nome}
            options={options}
            loading={false}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={'Orgão Jurisdicionado'}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="number"
                />
            )}
            disabled={true}
        />
    )
}